import { render } from "./AvailableSpotIcon.vue?vue&type=template&id=364781d4"
import script from "./AvailableSpotIcon.vue?vue&type=script&lang=js"
export * from "./AvailableSpotIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__